export enum DaoBundleType {
  PUBLISHED = 'PUBLISHED',
  THUMBNAIL = 'THUMBNAIL',
  TILE = 'TILE',
}
